import React from "react";

export default function ContactUs() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      {/* Heading */}
      <div className="text-center mx-20 my-8 text-4xl font-bold tracking-wide uppercase bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
        Contact Us
      </div>

      {/* Contact Information */}
      <div className="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-lg">
        <p className="text-center text-lg font-serif text-gray-700 leading-relaxed">
          <span className="text-gray-900 font-bold">Registered Office</span>
          <br />
          NO 13-261/308, Flat Number 308, Venugopal Nirmal Arcade, Medchal,
          Telangana 501401
          <br />
          <br />
          <span className="text-gray-900 font-bold">Corporate Offices</span>
          <br />
          Phone:{" "}
          <a href="tel:+9935238328" className="text-blue-500 hover:underline">
            9935238328
          </a>
          <br/>
          <br>
          </br>

         <b>E-mail</b>
         <br></br>
          <a
            href="mailto:mohit.srivastava@robusthrmservices.com"
            className="text-blue-500 hover:underline"
          >
            mohit.srivastava@robusthrmservices.com
          </a><br>
          </br>
          
          <a
            href="mailto:bhaskarreddy@robusthrmservices.com"
            className="text-blue-500 hover:underline"
          >
            bhaskarreddy@robusthrmservices.com
          </a>
          <br></br>
          <a
            href="mailto:customercare@robusthrmservices.com"
            className="text-blue-500 hover:underline"
          >
            customercare@robusthrmservices.com
          </a>
        </p>
      </div>
    </div>
  );
}
